class ProductType {
  constructor(params) {
    this.name = params.name;
    this.id = params.id;
    this.index = params.index;
    this.description = params.description;
  }
}

export { ProductType };



// WEBPACK FOOTER //
// ./src/models/ProductType.js